"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://github.com/wix-private/promote/blob/master/advanced-seo/advanced-seo-utils/src/private/types/ItemTypes.js
var GroupSEOItemType;
(function (GroupSEOItemType) {
    GroupSEOItemType["GROUPS_FEED"] = "GROUPS_FEED";
    GroupSEOItemType["GROUPS_MEDIA"] = "GROUPS_MEDIA";
    GroupSEOItemType["GROUPS_MEMBERS"] = "GROUPS_MEMBERS";
    GroupSEOItemType["GROUPS_ABOUT"] = "GROUPS_ABOUT";
    GroupSEOItemType["GROUPS_POST"] = "GROUPS_POST";
    GroupSEOItemType["GROUPS_COMMENT"] = "GROUPS_COMMENT";
})(GroupSEOItemType = exports.GroupSEOItemType || (exports.GroupSEOItemType = {}));
//# sourceMappingURL=GroupSEOItemType.js.map